import eventClient from "./event-client.js";
import axios from "../api/axios-instance.js";

eventClient.connect();

export const initPipelineUpdateEvent = () => {
  eventClient.subscribe("PIPELINE_UPDATED", () => {
    axios.storage?.clear?.();
  });
};

/**
 * Subscribe/listen to all SSE events.
 */
export const initialiseEvents = () => {
  initPipelineUpdateEvent();
};
